import { Injectable } from '@angular/core';
import { TaxLot } from '../../models/common/trading-common.model';

@Injectable()
export class TradingDataService {
    //#region - taxlot data
    defaultDispositionMethodResp: any;
    taxlotEnterpriseId: string;
    availableQty: number;
    theTaxLot: TaxLot;
    origSellTaxlot: TaxLot;   // For Sell Taxlot From UGL, we need have a original Taxlot data for Order Review
    //#endregion

    resetTaxlotData() {
        this.defaultDispositionMethodResp = null;
        this.taxlotEnterpriseId = null;
        this.theTaxLot = null;
        this.origSellTaxlot = null;
        this.availableQty = 0;
    }
}
